import angular from 'angular'
import drawBack from './drawBack'

export default angular
    .module('app.drawBack', [])
    .directive('drawBack', drawBack)
    .name



// WEBPACK FOOTER //
// ./src/components/drawBack/index.js